import {
  UPDATE_REQUEST_VALUE,
  GET_GAME_DETAIL,
  CREATE_GAME_LOADING,
  GET_GAME_THEME_CONFIG,
  GAME_CONFIG_TO_INITIAL,
  SAVE_GAME_CONFIG_SUCCESS,
  CLEAR_REQUEST_SAVE_GAME,
  CAMPAING_COUPON_LIST_REQUEST
} from "../actions/types"

const initialState = {
  requestSaveGameData: {
    gameId: 0,
    gameName: "",
    gameType: 0,
    gameStatus: 0,
    themeBackground: "",
    gameStartDate: "",
    gameEndDate: "",
    nextPageUrl: "",
    wheelColor: "",
    scratchImg: "",
    scratchPercentage: 25,
    backgroundImg: "",
    prizes: "",
    logoImg: "",
    btnImg: "",
    condition: "",
    backgroundColor: "#FFFFFF",
    backgroundType: 1,
    buttonType: 1,
    btnBgColor: "",
    wordBtn: "",
    fontColor: "#FFFFFF",
    wink: false,
    previewImg: "",
    nextToSetRewardBtn: true,
    gameCode: null,
    campaignCouponList: []
  },
  winkDisable: false,
  gameThemeOptions: [],
  gameCode: null,
  loading: false
}

const updateStateFromList = (state, payload) => {

  const updatedData = { ...state.requestSaveGameData }

  for (const key in updatedData) {
    if (payload.hasOwnProperty(key)) {
      updatedData[key] = payload[key]
    }
  }

  return {
    ...state,
    requestSaveGameData: updatedData
  }
}

const gameConfiguration = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case SAVE_GAME_CONFIG_SUCCESS:
      return {
        ...state,
        gameCode: payload
      }
    case GAME_CONFIG_TO_INITIAL:
      return {
        ...state,
        requestSaveGameData: initialState.requestSaveGameData
      }
    case UPDATE_REQUEST_VALUE:
      return {
        ...state,
        requestSaveGameData: {
          ...state.requestSaveGameData,
          [payload.name]: payload.value
        }
      }
    case GET_GAME_DETAIL:
      return updateStateFromList(state, payload)
    case GET_GAME_THEME_CONFIG:
      return {
        ...state,
        gameThemeOptions: payload.gameThemeOptions,
        requestSaveGameData: {
          ...state.requestSaveGameData,
          themeBackground: payload.themeBackground
        }
      }
    case CLEAR_REQUEST_SAVE_GAME:
      return {
        ...state,
        requestSaveGameData: initialState.requestSaveGameData,
        imgDisplay: initialState.imgDisplay,
        gameCode: initialState.gameCode
      }
    case CREATE_GAME_LOADING:
      return {
        ...state,
        loading: payload
      }
    case CAMPAING_COUPON_LIST_REQUEST:
      return {
        ...state,
        requestSaveGameData: {
          ...state.requestSaveGameData,
          campaignCouponList: payload
        }
      }
    default:
      return state
  }
}

export default gameConfiguration